import { CustomerFormData } from '../types';

const makeCustomerObj = (formState: CustomerFormData): Record<string, unknown> => {
  return {
    ...(formState.Id ? { Id: formState.Id } : {}),
    Name: formState.Name,
    TypeId: formState.TypeId,
    Address: formState.Address || '',
    WorkPhone: formState.WorkPhone || '',
    CellPhone: formState.CellPhone || '',
    HomePhone: formState.HomePhone || '',
    WorkEmail: formState.WorkEmail || '',
    PersonalEmail: formState.PersonalEmail || '',
    OtherEmail: formState.OtherEmail || '',
  };
};

export default makeCustomerObj;
